import { render, staticRenderFns } from "./CDSHeader.vue?vue&type=template&id=1a1a3ab8&scoped=true"
import script from "./CDSHeader.vue?vue&type=script&lang=js"
export * from "./CDSHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a3ab8",
  null
  
)

export default component.exports